<script setup>
import { onMounted, ref, watch } from 'vue';
import { useFVStore} from "@/stores/formvibes";
import Header from '../shared/header.vue';
import AnalyticsControl from './analtics-control-bar.vue';
import Chart from './chart.vue';
import { setToLocalStorage } from '../../stores/utils';
import { storeToRefs } from 'pinia';
import { axiosPost } from '../../Axios/post';
const store = useFVStore();

const {isNoPlugins, isLoading, generalStates, dates, notice} = storeToRefs(store);
const chartData = ref([]);
const chartType = ref('bar');
const noData = ref([]);

const chartOption = ref({
    scales: {
        y: {
            min: 0, // Ensures the y-axis starts at 0
            ticks: {
                stepSize: 5,
            },
        }
    }
});

onMounted( () => {
  getAnalyticsData();
});

watch([() => generalStates.value.queryParams], () => {
  getAnalyticsData();
});

const prepareChatData = (data) => {
	const attributes = [];
	attributes.labels = [];
	attributes.datasets = [];
	attributes.data = [];

	Object.keys(data).forEach((row) => {
		attributes.labels.push(data[row].Label);
		attributes.data.push(data[row].count);
	});

	const cData = {
		labels: attributes.labels,
		datasets: [
			{
				label: 'Leads',
				backgroundColor: '#0071a14D',
				borderColor: '#0071a1',
				borderWidth: 3,
				hoverBackgroundColor: '#00aadc',
				data: attributes.data,
			},
		],
	};

	if (Object.keys(cData).length > 0) {
		chartData.value = cData;
	}
	noData.value = attributes.data.every((d) => d === 0);
};

const getAnalyticsData = async () => {
	if (isNoPlugins.value) return;
	isLoading.value = true;
    let {queryParams} = generalStates.value;

	
    queryParams = {
      ...queryParams,
      fromDate: dates.value[0] || '',
      toDate: dates.value[1] || '',
    }
	try {
		const { data } = await axiosPost({
			queryParams,
			action: 'fv_get_analytics_data',
		});

		prepareChatData(data);
		store.resetError();
	} catch (error) {
			notice.value = {
			...notice.value,
			isError: true,
			message: error.message,
		}
	}
	finally {
		isLoading.value = false;
	}
};

const changeChartType = (value) => {
  chartType.value = value._value;
}

watch([notice], () => {
	if(notice.value.message === '') return;
    ElNotification({
        offset: 30,
        dangerouslyUseHTMLString: true,
        message: `<strong>${notice.value.message}</strong>`,
        type: notice.value.isError ? 'error' : 'success',
        class:'fv-items-center'
    })
})
</script>

<template>
    <el-config-provider>
      <div>
        <Header />
        <AnalyticsControl :getAnalyticsData="getAnalyticsData" :chartType="chartType" :changeChartType="changeChartType" />
        <Chart :chartData="chartData" :chartOption="chartOption" :chartType="chartType" :isLoading="isLoading" />
      </div>
  </el-config-provider>
</template>